import { SourceProvider } from '../SourceProvider';
import { RestoreView } from './RestoreView';
export var RestoreViewContainer = SourceProvider(RestoreView);